import { render, staticRenderFns } from "./EventBalance.vue?vue&type=template&id=79dc8fee&"
import script from "./EventBalance.vue?vue&type=script&lang=js&"
export * from "./EventBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports